<template>
    <Card>
        <template v-slot:icon>
            <i class="fas fa-cogs"/>
        </template>
        <template v-slot:title>
            {{ __('navigation.account_management') }}
        </template>
        <template v-slot:description>
            {{ __('user.delete.notice') }}
        </template>

        <FormGroupNew :label="__('actions.request_deletion')" required>
            <Checkbox type="danger" v-model="deletionRequestConfirmed">
                {{ __('user.delete.warning') }}
            </Checkbox>
        </FormGroupNew>

        <template v-slot:footer>
            <Link as="button"
                  class="btn btn-danger"
                  :href="$route('user.delete.request', [user.url_key])"
                  method="POST"
                  :disabled="!deletionRequestConfirmed"
            >
                <i class="fas fa-trash-restore"/>
                {{ __('user.delete.send_request') }}
            </Link>
        </template>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import DividerDotted from "@components/Form/DividerDotted.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import Checkbox from "@components/Form/Checkbox.vue";
import { Link } from '@inertiajs/vue2';

export default {
    components: {Checkbox, FormGroupNew, DividerDotted, Card, Link},

    props: {
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            deletionRequestConfirmed: false
        }
    }
}
</script>
